import { RecallBoeLocations } from "../../../../content/issues/how-to-recall/recall-boe";
import * as React from 'react';
export default {
  RecallBoeLocations,
  React
};